import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export abstract class EnvironmentService {
    abstract isElectron(): boolean;
    abstract runExecutable(
        executablePath: string,
        cmdLine: string,
        callback: (outTxt: string | undefined, errTxt: string | undefined, errMsg: string | undefined) => void
    ): void;
}
